import { defineMessages } from 'react-intl';

export const allureCashbackMessages = defineMessages({
  htmlTitle: {
    id: 'allure-cashback:page:htmlTitle',
    defaultMessage: 'Cashback',
  },
  navigationBarTitle: {
    id: 'allure-cashback:page:navigation-bar:title',
    defaultMessage: 'Cashback',
  },
  setupPageTitle: {
    id: 'allure-cashback:setup-page:title',
    defaultMessage: 'Get cashback today!',
    description: 'Displayed in uppercase via typography styles on the cashback setup page.',
  },
  setupPageSubtitle: {
    id: 'allure-cashback:setup-page:subtitle',
    defaultMessage: 'Enter your Venmo or PayPal account to receive cashback',
  },
  setupPaypalFieldLabel: {
    id: 'allure-cashback:setup-page:paypal-field-label',
    defaultMessage: 'PayPal email or mobile number',
  },
  setupVenmoFieldLabel: {
    id: 'allure-cashback:setup-page:venmo-field-label',
    defaultMessage: 'Venmo email or mobile number',
  },
  setupOrDivider: {
    id: 'allure-cashback:setup-page:or-divider',
    defaultMessage: 'OR',
  },
  setupCashoutIdentifierInvalid: {
    id: 'allure-cashback:setup-page:cashout-identifier-invalid',
    defaultMessage: 'Enter a valid email or mobile number',
    description: 'Validation error when PayPal/Venmo handle is neither email nor phone.',
  },
  redeemBalanceLabel: {
    id: 'allure-cashback:redeem-page:balance-label',
    defaultMessage: 'Your Cashback Balance',
  },
  redeemPaypalIdLabel: {
    id: 'allure-cashback:redeem-page:paypal-id-label',
    defaultMessage: 'Your PayPal ID',
  },
  redeemVenmoIdLabel: {
    id: 'allure-cashback:redeem-page:venmo-id-label',
    defaultMessage: 'Your Venmo ID',
  },
  redeemBalanceButton: {
    id: 'allure-cashback:redeem-page:redeem-button',
    defaultMessage: 'Redeem Balance',
  },
  removeCashoutModalTitle: {
    id: 'allure-cashback:redeem-page:remove-cashout-modal:title',
    defaultMessage: 'Remove cashback account',
  },
  removeCashoutModalDescription: {
    id: 'allure-cashback:redeem-page:remove-cashout-modal:description',
    defaultMessage: 'Are you sure you want to remove your cashback account?',
  },
  removeCashoutModalConfirmButtonText: {
    id: 'allure-cashback:redeem-page:remove-cashout-modal:confirm-button-text',
    defaultMessage: 'Remove',
  },
  removeCashoutModalCancelButtonText: {
    id: 'allure-cashback:redeem-page:remove-cashout-modal:cancel-button-text',
    defaultMessage: 'Cancel',
  },
  removeCashoutButtonAriaLabel: {
    id: 'allure-cashback:redeem-page:remove-cashout-button:aria-label',
    defaultMessage: 'Remove cashback account',
  },
});
